import { useContext } from 'react';

import { SearchFormContext } from './SearchFormContext.js';
import { useSearchFormStore } from './SearchFormStore.js';

export const useSearchForm = () => {
  const store = useSearchFormStore();
  const ctx = useContext(SearchFormContext);

  return ctx ?? store;
};

export default useSearchForm;
